import React from 'react';
import Select from 'react-select';
import moment from 'moment';
import PropTypes from 'prop-types';

const momentPropType = (props, propName, componentName) => {
  const val = props[propName];
  if (val != null && !moment.isMoment(val)) {
    return new Error(`Invalid prop ${propName} supplied to ${componentName}. Expected a moment instance.`);
  }
  return null;
};

function MonthSelector({
  name = null,
  value = moment().startOf('month'),
  onChange = null,
  start = moment().subtract(6, 'months').startOf('month'),
  end = moment().startOf('month'),
  newestFirst = true,
}) {
  const options = [];
  let valueObject;

  let date = start.clone();

  while (date <= end) {
    options.push({ label: date.format('M/YYYY'), value: date.clone() });
    date = date.add(1, 'month');
  }

  if (newestFirst) {
    options.reverse();
  }

  options.forEach((item) => {
    if (item.value.format('M/YYYY') === value.format('M/YYYY')) {
      valueObject = item;
    }
  });

  return (
    <Select
      name={name}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 1071 }) }}
      menuPortalTarget={document.body}
      onChange={(item) => onChange(item.value)}
      options={options}
      value={valueObject}
    />
  );
}

MonthSelector.propTypes = {
  name: PropTypes.string,
  value: momentPropType,
  onChange: PropTypes.func,
  start: momentPropType,
  end: momentPropType,
  newestFirst: PropTypes.bool,
};

MonthSelector.defaultProps = {
  name: null,
  value: moment().startOf('month'),
  onChange: null,
  start: moment().subtract(6, 'months').startOf('month'),
  end: moment().startOf('month'),
  newestFirst: true,
};

export default MonthSelector;
